import { Injectable } from '@angular/core';
import { ReorderItem } from '@app/reorder-modal/reorder-modal.component';
import { FlexService } from '@app/flex-framework/services/flex-framework.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TargetsService } from '@app/shared/services/targets.service';
import { map } from 'rxjs/operators';
import { FlexRowSummary } from '../flex-api.model';

/**
 * Service to communicate when the reorder button is clicked in the flex-view-header component and
 * common functions used for reordering sections.
 */
@Injectable({
  providedIn: 'root',
})
export class FlexRowReorderService {
  constructor(
    private flexService: FlexService,
    private translate: TranslateService,
    private targetsService: TargetsService
  ) {}
  private rowsReordered = new Subject<void>();
  private isReorderModeActivated = new BehaviorSubject<boolean>(false);
  public get onRowsReordered$() {
    return this.rowsReordered.asObservable();
  }

  public get isReorderModeActive$(): Observable<boolean> {
    return this.isReorderModeActivated.asObservable();
  }

  public reorderRows() {
    this.rowsReordered.next();
  }

  public toggleReorderMode(isReorderMode: boolean): void {
    this.isReorderModeActivated.next(isReorderMode);
  }

  public getReorderData(section: FlexRowSummary[]): ReorderItem[] {
    return section.map((rowSummary) => {
      const displayInfo = this.flexService.getRowDisplayInfo(
        rowSummary.resourceType
      );
      return {
        node: rowSummary.parentNode,
        title: this.translate.instant('dgFlexRow_SectionTypeLabelFormat', {
          sectionType: displayInfo.displayType,
        }),
        subText: rowSummary.name || displayInfo.displayType,
      };
    });
  }

  public updateRowOrder(reorderData: ReorderItem[], targetId: number) {
    const nodes = reorderData.map((section) => section.node);
    const NodeMap = {};
    nodes.forEach((node, idx) => {
      NodeMap[node] = `/${idx + 1}/`;
    });
    return this.targetsService
      .reorderTargetSections({
        targetId,
        nodes: NodeMap,
      })
      .pipe(
        map((response) => {
          return {
            response,
            nodes,
          };
        })
      );
  }
}
